export default __webpack_public_path__ + "static/media/icon-whatsapp.6544a35f.svg";